export default __webpack_public_path__ + "static/green-e71348288d8b4c9e8b80bf4f1cbbdef1.jpeg";